import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const CheckboxSection = styled("div")(() => ({
  "&:last-child": {
    "& hr": {
      display: "none !important",
    },
  },
}));

export const FieldGroupTitle = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 600,
  color: colors.gray500,
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  marginBottom: "8px",

  "&:first-of-type": {
    marginTop: "0px",
  },
}));

export const CheckboxGroup = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: "12px",
  alignItems: "center",

  "&:first-child": {
    marginTop: "4px",
  },

  "& .MuiFormControlLabel-root": {
    margin: "0",
    alignItems: "center",
    flex: "0 0 auto",

    "& .MuiCheckbox-root": {
      padding: "4px",
      color: colors.gray400,

      "&.Mui-checked": {
        color: colors.brandBlue500,
      },
    },

    "& .MuiFormControlLabel-label": {
      fontFamily: "Manrope",
      fontSize: "14px",
      fontWeight: 400,
      color: colors.gray700,
      lineHeight: "20px",
      paddingLeft: "4px",
      whiteSpace: "nowrap",
    },
  },
}));
